import { render, staticRenderFns } from "./MicroeconomicsPage.vue?vue&type=template&id=3e5c0461&"
import script from "./MicroeconomicsPage.vue?vue&type=script&lang=ts&"
export * from "./MicroeconomicsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports